import {
    FETCH_GOLF_HISTORICAL_SHOTS,
    FETCH_GOLF_HISTORICAL_SHOTS_FETCHING,
    FETCH_GOLF_HISTORICAL_SHOTS_SUCCESS,
    FETCH_GOLF_HISTORICAL_SHOTS_FAIL
} from 'actions/golfShotsActionTypes';

const INITIAL_STATE = {
    historicalShots: {},
    historicalShotsFetching: false,
    historicalShotsFetchSuccess: false,
    historicalShotsFetchFail: false
};

// ======= Fetching Handlers =======
const historicalShotsFetching = (state) => {
    return {
        ...state,
        historicalShotsFetching: true,
        historicalShotsFetchSuccess: false,
        historicalShotsFetchFail: false
    };
};

const historicalShotsFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        historicalShots: success
            ? {
                  ...state.historicalShots,
                  [action.courseId]: action.historicalShots
              }
            : state.historicalShots,
        historicalShotsFetching: false,
        historicalShotsFetchSuccess: success,
        historicalShotsFetchFail: !success
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_GOLF_HISTORICAL_SHOTS_FETCHING]: historicalShotsFetching,
    [FETCH_GOLF_HISTORICAL_SHOTS_SUCCESS]: historicalShotsFetchFinished(true),
    [FETCH_GOLF_HISTORICAL_SHOTS_FAIL]: historicalShotsFetchFinished(false)
};

// ======= Default Action =======
export default function golfHistoricalShots(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getHistoricalShots = (state, courseId) => {
    return state.golfHistoricalShots.historicalShots[courseId] || {};
};

export const isHistoricalShotsFetching = (state) => {
    return state.golfHistoricalShots.historicalShotsFetching;
};

export const didHistoricalShotsFetchFail = (state) => {
    return state.golfHistoricalShots.historicalShotsFetchFail;
};

export const didHistoricalShotsFetchSucceed = (state) => {
    return state.golfHistoricalShots.historicalShotsFetchSuccess;
};

// ======= Actions =======

export function fetchHistoricalShots(courseId) {
    return {
        type: FETCH_GOLF_HISTORICAL_SHOTS,
        courseId: courseId
    };
}
